import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  Box,
} from '@razorpay/blade/components';
import exitBulkUploadsExit from 'assets/bulkUploads/exit_bulk_uploads_exit.svg';
import { WizardProgressView, WizardHeader } from 'components/WizardViews/components';

type PageHeaderProps = {
  headerText: string;
  currentStep?: number;
  showProgress?: boolean;
};

const ConfirmExitModal = ({ isOpen, onDismiss }: { isOpen: boolean; onDismiss: () => void }) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ModalHeader title="" />
      <ModalBody>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          gap="spacing.5">
          <img
            loading="lazy"
            src={exitBulkUploadsExit}
            alt=""
            style={{ height: '88px', width: '88px' }}
          />
          <Text color="surface.text.gray.normal" size="large">
            Exit bulk upload?
          </Text>
          <Text color="surface.text.gray.subtle">
            Please note any progress made till now will not be saved
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.5" justifyContent="flex-end">
          <Button
            variant="tertiary"
            onClick={() => {
              onDismiss();
            }}>
            Go Back
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              window.location.href = '/dashboard';
              onDismiss();
            }}>
            Exit now
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export const PageHeader = ({ headerText, showProgress }: PageHeaderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <WizardHeader
        heading=""
        subHeading={headerText}
        onCloseClick={() => {
          setIsModalOpen(true);
        }}>
        {Boolean(showProgress) && (
          <WizardProgressView
            steps={[
              { label: 'Upload Template', position: 1 },
              { label: 'Preview Details', position: 2 },
            ]}
          />
        )}
      </WizardHeader>
      <ConfirmExitModal isOpen={isModalOpen} onDismiss={() => setIsModalOpen(false)} />
    </>
  );
};
